import { render, staticRenderFns } from "./SegmentEdit.vue?vue&type=template&id=6ac835d6"
import script from "./SegmentEdit.vue?vue&type=script&lang=js"
export * from "./SegmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports